<template>
    <div v-zoezi-editable="{prop: 'html', html: true, multiline: true}">
        <v-runtime-template :template="sanitizedHtml"></v-runtime-template>
    </div>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";
import { VBtn, VChip, VImg, VRow, VCol } from 'vuetify/lib'
export default {
    name: 'zoezi-html',

    zoezi: {
        title: 'Html',
        icon: 'mdi-code-tags'
    },

    components: {
        VRuntimeTemplate,
        /* eslint-disable vue/no-unused-components */
        VBtn,
        VChip,
        VImg,
        VRow,
        VCol
    },
    props: {
        html: {
            title: 'HTML text',
            type: String,
            fulltype: 'html',
            default:
                `<div class="fill-height zoezi-html-default">
  <h3>Html-text</h3>
</div>`
        }
    },
    computed: {
        sanitizedHtml() {
            let html = this.html || '';
            if (!html.trim().startsWith('<')) {
                // Wrap text in a <div> if it's not pure HTML
                html = `<div>${html}</div>`;
            }
            return html;
        }
    },
    data: () => ({
    })
}
</script>
